export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
}

export function formatSignedCurrency(value: number, alwaysSign = false): string {
  const abs = formatCurrency(Math.abs(value));
  if (value < 0) return `-${abs}`;
  if (value > 0 || alwaysSign) return `+${abs}`;
  return abs;
}
